// src/hooks/useCentrosProfesor.ts
import { useCentros, Centro } from "./useCentros";
import { useState, useEffect } from "react";
import api from "../api/axios";

export function useCentrosProfesor(idProfesor: number) {
  const { rows: all, loading } = useCentros(); // todos los centros
  const [rows, setRows] = useState<Centro[]>([]);

  useEffect(() => {
    if (!idProfesor) {
      setRows([]);
      return;
    }

    api.get(`/profesores/${idProfesor}/centros`).then((r) => {
      // ▶ nos quedamos sólo con el objeto ‘centro’
      const ids = r.data.map((pc: any) => pc.idCentro);
      setRows(all.filter((c) => ids.includes(c.id)));
    });
  }, [idProfesor, all]);

  return { rows, loading };
}
